import React, { useState, useEffect } from 'react';
import { Table, Drawer, Button, Popconfirm, message } from 'antd';
import { DeleteOutlined, UndoOutlined,ArrowLeftOutlined } from '@ant-design/icons';
import API from '../../API/API'; // Import the API class

const RecycleBin = ({ visible, onClose,onRestoreSuccess  }) => {
    const [deletedData, setDeletedData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [drawerWidth, setDrawerWidth] = useState(window.innerWidth);

      useEffect(() => {
            const handleResize = () => setDrawerWidth(window.innerWidth);
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);
    
        
        const fetchDeletedData = async (page, pageSize) => {
            setLoading(true);
            try {
                const response = await API.GetDeletedLead({ page, limit: pageSize });
        
                if (response.status) {
                    const { data: results, pagination: paginationData } = response;
                    setDeletedData(results);
                    setPagination({
                        current: paginationData.currentPage,
                        pageSize: paginationData.pageSize,
                        total: paginationData.totalItems,
                    });
        
                    console.log('Data fetched successfully');
                } else {
                    throw new Error(response.message || 'Failed to fetch deleted data');
                }
            } catch (error) {
                console.error('Error fetching deleted data:', error);
            } finally {
                setLoading(false);
            }
        };
        
        
        // Re-fetch when `visible` changes or pagination updates
        useEffect(() => {
            if (visible) {
                fetchDeletedData(pagination.current, pagination.pageSize);
            }
        }, [visible, pagination.current, pagination.pageSize]);
        

    const deleteRecords = async () => {
        if (selectedRowKeys.length === 0) {
            message.warning('No rows selected.');
            return;
        }
    
        try {
            // Send all selected IDs in a single request
            const response = await API.HardDeleteLead(selectedRowKeys);
    
            if (response.status) {
                // Update the UI by removing deleted records
                setDeletedData((prev) => prev.filter((item) => !selectedRowKeys.includes(item._id)));
                setSelectedRowKeys([]);
                message.success('Selected records hard deleted successfully!');
            } else {
                message.error(response.message || 'Failed to hard delete selected records.');
            }
        } catch (error) {
            console.error('Error hard deleting records:', error);
            message.error('Failed to hard delete selected records.');
        }
    };


 

    const handleBatchDelete = async () => {
        if (selectedRowKeys.length === 0) {
            message.warning('No records selected.');
            return;
        }
        await deleteRecords(selectedRowKeys);
    };

    const restoreRecords = async (ids) => {
        try {
            const responses = await Promise.all(ids.map(async (_id) => {
                const response = await API.RestoreLead(_id);
                if (!response.status) {
                    throw new Error(`Failed to restore record with ID: ${_id}`);
                }
                return response;
            }));
    
            message.success('Selected records restored successfully.');
            setDeletedData((prev) => prev.filter((item) => !ids.includes(item._id)));
            setSelectedRowKeys([]); // Clear selection
            
            if (onRestoreSuccess) {
                onRestoreSuccess();
            }
        } catch (error) {
            console.error('Error restoring records:', error);
            message.error('Failed to restore selected records.');
        }
    };
    

    const handleRestore = async (_id) => {
        await restoreRecords([_id]);
    };

    const handleBatchRestore = async () => {
        if (selectedRowKeys.length === 0) {
            message.warning('No records selected.');
            return;
        }
        await restoreRecords(selectedRowKeys);
    };

    const columns = [
               { title: 'Year', dataIndex: ['vehicleInfo', 'year'], key: 'year' },
               { title: 'Make', dataIndex: ['vehicleInfo', 'make'], key: 'make' },
               { title: 'Model', dataIndex: ['vehicleInfo', 'model'], key: 'model' },
               { title: 'Part', dataIndex: ['vehicleInfo', 'part'], key: 'part' },
       
               { title: 'Full Name', dataIndex: ['personalInfo', 'fullName'], key: 'fullName' },
               { title: 'Lead Stage', dataIndex: 'leadStage', key: 'leadStage', width: 150 },
                {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '10px' }}>
                    <Popconfirm
                        title="Are you sure you want to restore this record?"
                        onConfirm={() => handleRestore(record._id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="link"><UndoOutlined style={{ fontSize: "20px" }} /></Button>
                    </Popconfirm>
                </div>
            ),
        },
    ];

    const rowSelection = {
        selectedRowKeys,
        onChange: (keys) => setSelectedRowKeys(keys),
    };

    return (
        <Drawer
             title={null}
            placement="right"
            width={drawerWidth}
            // onClose={onClose}
            closable={false}
            open={visible}
        >
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <Button type="link" onClick={onClose} style={{ fontSize: '16px', padding: 0 }}>
                    <ArrowLeftOutlined /> Back
                </Button>
                <span style={{ margin: '0 10px' }}>/</span>
                <strong style={{ fontSize: '18px' }}>Delete List</strong>
            </div>

            <div style={{ marginBottom: 16 }}>
                <Popconfirm
                    title="Are you sure you want to delete the selected records Permanently?"
                    onConfirm={handleBatchDelete}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button
                        danger
                        disabled={selectedRowKeys.length === 0}
                        style={{
                            backgroundColor: '#ff0000',
                            color: 'white',
                            marginRight: '15px',
                            display: selectedRowKeys.length === 0 ? 'none' : 'inline-block',
                        }}                    >
                        <DeleteOutlined /> Delete
                    </Button>
                </Popconfirm>
            </div>
            <Table
                columns={columns}
                dataSource={deletedData}
                loading={loading}
                rowSelection={rowSelection}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    showSizeChanger: true,
                    // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`, // ✅ This shows "1-10 of 100"
                    onChange: (page, pageSize) => {
                        setPagination((prev) => ({ ...prev, current: page, pageSize }));
                    },
                    onShowSizeChange: (current, newSize) => {
                        setPagination({ current: 1, pageSize: newSize }); // Reset to page 1 when changing size
                    },
                }}
                rowKey={(record) => record._id}
                scroll={{
    x: 'max-content',
    y: '55vh'
  }}  
            />
        </Drawer>
    );
};

export default RecycleBin;